if (!customElements.get("lsg-header")) customElements.define("lsg-header", class LSGHeader extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            navbar: ".js-lsg-header-navbar",
            triggerContainer: ".lsg-header__desk-menu .js-lsg-header-trigger-container",
            toggleButton: ".js-lsg-header-toggle-button",
            triggerContainerMob: ".lsg-header__mobile-menu .js-lsg-header-trigger-container",
            mobileMenuToggle: ".js-toggle-menu",
            sunToggleButton: ".js-lsg-header-sub-toggle-button"
        };


        this.mouseOutTimer;             // timer used to delay hiding of menu after mouse leaves
        this.mouseOutHideDelay = 300;  // time (in ms) before menu is closed after mouse leaves


        this.navbar = this.querySelector(this.selectors.navbar);
        this.triggerContainer = this.querySelectorAll(this.selectors.triggerContainer);
        this.toggleButtons = this.querySelectorAll(this.selectors.toggleButton);
        this.sunToggleButton = this.querySelectorAll(this.selectors.sunToggleButton);

        this.triggerContainerMob = this.querySelectorAll(this.selectors.triggerContainerMob);
        this.mobileMenuToggle = this.querySelectorAll(this.selectors.mobileMenuToggle);

        this.init();
    }

    hideMobMenu(el) {
        document.querySelector('.js-lsg-header-mobile-menu').classList.remove('is-open');
        el.setAttribute('aria-expanded', false);
        document.querySelector('body').classList.remove('is-show-mob-menu');
    }

    showMobMenu(el) {
        el.setAttribute('aria-expanded', true);
        document.querySelector('.js-lsg-header-mobile-menu').classList.add('is-open');
        document.querySelector('body').classList.add('is-show-mob-menu');
    }

    init() {

        this.mobileMenuToggle.forEach(el => {
            el.addEventListener('click', (e) => {
                if (el.getAttribute('aria-expanded') == 'true') {
                    this.hideMobMenu(el);
                } else {
                    this.showMobMenu(el);
                }
            });
        })
        // Show the menu on mouse hover of the trigger
        this.triggerContainer.forEach(el => {
            el.addEventListener('mouseover', (e) => {
                this.showMenu(el);
                clearTimeout(this.mouseOutTimer);
            });


            // Hide the menu when mouse hover leaves both the trigger and menu fly-out, but only after a short delay to help people jerky mouse movements (like those using head/eye trackers)
            el.addEventListener('mouseout', (e) => {
                this.mouseOutTimer = setTimeout(() => {
                    this.hideElMenu(el);
                }, this.mouseOutHideDelay);
            });
            // Toggle the menu when the trigger is activated
            el.querySelector(this.selectors.toggleButton).addEventListener('click', () => {
                this.toggleMenu(el);
            });
        });


        // Show the menu on mouse hover of the trigger
        this.triggerContainerMob.forEach(el => {
            // Toggle the menu when the trigger is activated
            el.querySelector(this.selectors.toggleButton).addEventListener('click', () => {
                this.toggleMenu(el);
            });
        });


        // Hide the menu when the user tabs out of it
        this.triggerContainer.forEach(el => {
            el.addEventListener('keydown', (e => {
                this.triggerKeydownHandler(e, el);
            }));
        });

        // // Close the menu when the close button is clicked
        // this.closeButton.addEventListener('click', hideMenu);
        //
        // // Close the menu AND return focus to the trigger when the close button is activted by keyboard
        // this.closeButton.addEventListener('keydown', function(e) {
        //     if(e.key == 'Enter' || e.key == ' ') {
        //         e.preventDefault();
        //         hideMenu();
        //         this.toggleButton.focus();
        //     }
        // });
        //


        // Close the menu when the user activates something outside the this.navbar.
        document.body.addEventListener('click', () => {
            this.handleBodyClick()
        });

        this.sunToggleButton.forEach(el=>{
            el.addEventListener("click",()=>{
                const isExpanded = el.getAttribute('aria-expanded');
                el.setAttribute('aria-expanded', isExpanded == "true"? false: true);
            })
        })
    }


    /**
     Menu visibility
     */
    showMenu(el) {
        this.hideMenu();
        el.querySelector(this.selectors.toggleButton).setAttribute('aria-expanded', true);
        el.classList.add('is-show-sub-menu');
    }

    hideElMenu(el) {
        el.querySelector(this.selectors.toggleButton).setAttribute('aria-expanded', false);
        el.classList.remove('is-show-sub-menu');
    }

    hideMenu() {
        this.toggleButtons.forEach(btn => {
            btn.setAttribute('aria-expanded', false);
        });
        this.triggerContainer.forEach(el => {
            el.classList.remove('is-show-sub-menu');
        });
        this.triggerContainerMob.forEach(el => {
            el.classList.remove('is-show-sub-menu');
        })
    }

    toggleMenu(el) {
        if (el.querySelector(this.selectors.toggleButton).getAttribute('aria-expanded') == 'true') {
            this.hideMenu(el);
        } else {
            this.showMenu(el);
        }
    }


    /**
     Event handlers
     */
    handleBodyClick(e) {
        // Hide the menu if the user clicks anywhere other than on the this.navbar or one of it's child menus
        if (!this.navbar?.contains(e.target)) {
            this.hideMenu();
        }
    }

    triggerKeydownHandler(e, el) {
        const lastMenuItems = el.querySelectorAll('a, button');
        const lastMenuItem = lastMenuItems[lastMenuItems.length - 1];
        // Hide the menu a keyboard user tabs out of it
        if ((e.key === 'Tab' && !e.shiftKey && e.target === lastMenuItem) || e.key == 'Escape') {
            this.hideElMenu(el);

            // Move focus back to the menu toggle button if Escape was pressed
            if (e.key == 'Escape') {
                el.querySelector(this.selectors.toggleButton).focus();
            }
        }
    }

});


if (!customElements.get("mega-menu")) customElements.define("mega-menu", class megaMenu extends HTMLElement {

    constructor() {
        super();
        this.selectors = {
            navItem: '.js-header-sub-wrapper',
            navItemMob: ".lsg-header__mobile-menu .js-header-sub-wrapper",
            desktopMegaMenu: ".js-mega-menu-mobile-desktop"
        };

        this.body = document.querySelector('body');
        this.dataParentLink = this.getAttribute('data-parent-link');
        this.navItem = document.querySelector(`${this.selectors.navItem}[data-navlink-handle="${this.dataParentLink}"]`);
        this.desktopMegaMenu = this.querySelector(this.selectors.desktopMegaMenu);
        this.navItemMob = document.querySelector(`${this.selectors.navItemMob}[data-navlink-handle="${this.dataParentLink}"]`);

        this.init();
    }

    initMegaMenu() {
        if (this.desktopMegaMenu) {
            this.navItem.classList.add('has-mega-menu');
            this.navItem.innerHTML = '';
            this.navItem.append(this.desktopMegaMenu);
            this.mobMegaMenu = this.desktopMegaMenu.cloneNode(true);

            if (this.navItemMob != null) {
                this.navItemMob.classList.add('has-mega-menu');

                this.navItemMob.innerHTML = '';
                this.navItemMob.append(this.mobMegaMenu);

                const shopMobNavToggle = this.navItemMob.closest('li').querySelector('.js-lsg-header-toggle-button[aria-controls="shop_mob"]');
                if (shopMobNavToggle != null) {
                    shopMobNavToggle.setAttribute('aria-expanded', true);
                    shopMobNavToggle.parentNode.classList.add('is-show-sub-menu')
                }
            }

        }
    }


    init() {
        if (this.navItem != null) {
            this.initMegaMenu();

        }
    }
});
